<template>
    <div class="container">
        <div>
            <p>{{user.name.toUpperCase() + ' ' +
                user.firstname.charAt(0).toUpperCase() + user.firstname.slice(1)}}
            </p>
        </div>

        <a v-if="user.tel" :href="'tel:'+user.tel">{{$formatTel(user.tel)}}</a>
        <a v-else href=""></a>
        <a :href="'mailto:'+user.email" target="_blank">{{user.email}}</a>
        <div>
            <p>{{$displayRole(family.role)}}</p>
        </div>

        <div>
            <!--            <uni-cta-link :to="{name: 'admin.families.edit', params: {id: user.family_id}}"-->
            <!--                           class="uni-cta-link&#45;&#45;secondary uni-cta-link&#45;&#45;extra-small">{{isMobile ? 'Famille' : 'Voir la famille'}}-->
            <!--            </uni-cta-link>-->
        </div>
    </div>
</template>

<script>
    import Pill from "../a-elements/pill";
    import UniButton from "../a-elements/UniButton";
    import UniCtaLink from "../a-elements/UniCtaLink";

    export default {
        name: "adminInline",
        components: {UniCtaLink, UniButton, Pill},
        props: {
            user: Object,
            family: Object,
            list: {
                type: Boolean,
                default: false
            },
            search: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                isMobile: true
            }
        },

        computed: {
            certificateColor() {
                if (this.user.medical_certificate) {
                    if (this.user.medical_certificate.year) {
                        return "pill-success"
                    } else {
                        return "pill-warning"
                    }
                } else {
                    return "pill-danger"
                }
            },
            paymentColor() {
                if (this.user.payments.length === 0) {
                    return "pill-danger"
                } else {
                    if (this.user.payments.length === 1) {
                        return this.whichPaymentColor(this.user.payments[0].status)
                    } else {
                        return this.whichPaymentColor(this.user.payments[this.$currentTrimestre() - 1].status)
                    }
                }
            }
        },
        methods: {
            displayTel(bool) {
                if (this.user.legal_resps.length > 0) {
                    if (bool) {
                        return this.$formatTel(this.user.legal_resps[0].tel)
                    } else {
                        return this.user.legal_resps[0].tel
                    }
                } else {
                    if (bool) {
                        return this.$formatTel(this.user.tel)
                    } else {
                        return this.user.tel
                    }
                }
            },
            whichPaymentColor(status) {
                if (status) {
                    return "pill-success"
                } else if (status === null) {
                    return "pill-warning"
                } else {
                    return "pill-danger"
                }
            }
        },

        mounted() {
            const width = window.innerWidth || document.documentElement.clientWidth ||
                document.body.clientWidth
            this.isMobile = width < 768
        }


    }
</script>

<style scoped lang="scss">

    .container {
        width: 100%;
        border-radius: var(--radius-big);
        background: var(--color-grey-light-2);
        color: var(--color-black);
        padding: 8px 16px;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        align-items: center;
        gap: .5rem;

        > div:first-child {
            width: 150px;
        }

        a {
            margin: 0;
        }

        p {
            margin: 0;
        }

        margin-bottom: 16px;

    }

    @include screen-l {
        .container {
            > div:first-child {
            }

            > div:nth-child(2) {
                justify-self: center;
            }

            > div:nth-child(3) {
                width: 80px;
                justify-self: center;
            }
        }
    }

</style>
